import type { ReactElement } from 'react';
import {
  SESSION_ID_AGENT_HINT,
  SESSION_ID_TRANSCRIPT_HINT,
} from './AlertSecretDetails.helpers';
import type { SessionTranscriptHintProps } from './sessionTranscriptHintLabel';

/**
 * Transcript hint shared by the grouped Session ID popover and the Alert
 * Variations session-id tooltip. The first line differs; the rest does not.
 */
export function SessionTranscriptHintBody({
  firstLine,
  firstLineClassName,
  location,
  altLocation,
}: SessionTranscriptHintProps): ReactElement {
  return (
    <div className="space-y-1">
      <p className={firstLineClassName}>{firstLine}</p>
      {location && <p>{SESSION_ID_TRANSCRIPT_HINT}</p>}
      {location && (
        <p>
          Location: <code className="font-mono break-all">{location}</code>
        </p>
      )}
      {altLocation && (
        <p>
          {altLocation.when}:{' '}
          <code className="font-mono break-all">{altLocation.path}</code>
        </p>
      )}
      <p>{SESSION_ID_AGENT_HINT}</p>
    </div>
  );
}
